import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL } from './legalConfig';
import './Legal.scss';

const Privacy: React.FC = () => (
  <article className="legal">
    <h1 className="legal__title">Политика конфиденциальности</h1>
    <p className="legal__meta">Редакция от {LEGAL.updatedAt}</p>

    <h2>1. Общие положения</h2>
    <p>
      Настоящая политика определяет порядок обработки персональных данных пользователей сайта {LEGAL.siteName}
      {' '}(далее — «Сайт») и меры по их защите. Оператор персональных данных: {LEGAL.operatorName},
      {' '}{LEGAL.operatorDetails}, {LEGAL.operatorAddress} (далее — «Оператор»).
    </p>
    <p>
      Политика разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».
      Регистрируясь на Сайте, пользователь подтверждает согласие с условиями настоящей политики.
    </p>

    <h2>2. Какие данные мы обрабатываем</h2>
    <ul>
      <li>фамилия, имя, отчество;</li>
      <li>дата рождения и пол;</li>
      <li>город;</li>
      <li>адрес электронной почты;</li>
      <li>пароль (хранится только в виде необратимого хэша);</li>
      <li>выбранная роль на Сайте (спортсмен, тренер и т. д.);</li>
      <li>
        данные для участия в турнирах: вес, спортивная школа или клуб, тренер, спортивный разряд, весовая и
        возрастная категории, результаты соревнований;
      </li>
      <li>технические данные: IP-адрес, сведения о браузере, токен авторизации в браузере.</li>
    </ul>

    <h2>3. Цели обработки</h2>
    <ul>
      <li>регистрация и идентификация пользователя, подтверждение адреса электронной почты;</li>
      <li>приём заявок на турниры, формирование категорий, жеребьёвки, турнирных сеток и протоколов;</li>
      <li>публикация списков участников и результатов соревнований;</li>
      <li>связь с пользователем по вопросам участия в турнирах и работы Сайта;</li>
      <li>обеспечение безопасности Сайта и предотвращение злоупотреблений.</li>
    </ul>

    <h2>4. Какие данные видны другим пользователям</h2>
    <p>
      В списках участников и результатах турниров отображаются фамилия, имя, город, спортивная школа, тренер,
      разряд, категории и результаты. Вместо полной даты рождения показывается только год рождения. Адрес
      электронной почты и полная дата рождения доступны только самому пользователю и организаторам (администраторам).
    </p>

    <h2>5. Несовершеннолетние</h2>
    <p>
      Если пользователю меньше 18 лет, регистрация возможна только с согласия его родителя или иного законного
      представителя. Подтверждая это на форме регистрации, пользователь заверяет, что такое согласие получено.
    </p>

    <h2>6. Правовые основания, сроки и способы обработки</h2>
    <p>
      Обработка осуществляется на основании согласия субъекта персональных данных, а также для исполнения
      договора (участие в турнире). Данные обрабатываются с использованием средств автоматизации и хранятся
      до достижения целей обработки либо до отзыва согласия, если иной срок не требуется по закону.
    </p>

    <h2>7. Передача третьим лицам</h2>
    <p>
      Оператор не продаёт персональные данные. Данные могут передаваться только провайдерам, обеспечивающим
      работу Сайта (хостинг, отправка электронных писем), а также по требованию уполномоченных государственных
      органов в случаях, предусмотренных законом.
    </p>

    <h2>8. Меры защиты</h2>
    <p>
      Применяются организационные и технические меры: передача данных по защищённому соединению, хранение
      паролей в виде хэшей, разграничение доступа, ограничение частоты запросов и защита от подбора паролей.
    </p>

    <h2>9. Права пользователя</h2>
    <p>
      Пользователь вправе запросить сведения о своих данных, потребовать их уточнения, блокирования или удаления,
      а также отозвать согласие на обработку. Для этого направьте обращение на {LEGAL.contactEmail}. Отзыв согласия
      может сделать невозможным дальнейшее использование Сайта. Оператор рассматривает обращения в сроки,
      установленные законом.
    </p>

    <h2>10. Изменение политики</h2>
    <p>
      Оператор вправе изменять политику. Актуальная редакция всегда доступна на этой странице.
    </p>

    <p className="legal__back">
      <Link to="/terms">Пользовательское соглашение</Link>
      {' · '}
      <Link to="/">На главную</Link>
    </p>
  </article>
);

export default Privacy;
